import { z } from 'zod';
/**
 * 오버레이 능력 토큰 kind. 한 kind는 그 오버레이 하나이며, 살아 있는 비밀은 슬롯 최대 둘이다.
 * 경로·발급·resolve Guard가 동일 enum을 쓴다.
 */
export const OVERLAY_KINDS = [
    'alert',
    'menu',
    'game_dice',
    'game_draw',
    'game_wheel',
];
export const overlayKindSchema = z.enum(OVERLAY_KINDS);
export function isOverlayKind(value) {
    return OVERLAY_KINDS.includes(value);
}
//# sourceMappingURL=kinds.js.map